import { X509, KEYUTIL, zulutodate } from 'jsrsasign'

export const checkCertificateValidity = (pemCert) => {
  try {
    const x509 = new X509()
    x509.readCertPEM(pemCert)

    const currentTime = new Date()
    const notBefore = zulutodate(x509.getNotBefore())
    const notAfter = zulutodate(x509.getNotAfter())

    if (currentTime >= notBefore && currentTime <= notAfter) {
      return true
    } else {
      return false
    }
  } catch (error) {
    return false
  }
}

const getPublicKeyFromCert = (certPEM) => {
  try {
    const cert = new X509()
    cert.readCertPEM(certPEM)
    return cert.getPublicKey()
  } catch (error) {
    return null
  }  
}

const getPublicKeyFromPrivateKey = (keyPEM) => {
  try {
    const privateKey = KEYUTIL.getKey(keyPEM)

    if (privateKey.type === 'RSA') {
      return KEYUTIL.getKey({ n: privateKey.n, e: privateKey.e })
    }

    if (privateKey.type === 'EC') {
      return privateKey
    }

    return null
  } catch (error) {
    return null
  }
}

export const checkCertificateMatch = (pemCert, privateKey) => {
  try {
    const certPublicKey = getPublicKeyFromCert(pemCert)
    const privateKeyPublicKey = getPublicKeyFromPrivateKey(privateKey)

    const certPublicKeyPEM = KEYUTIL.getPEM(certPublicKey)
    const privateKeyPublicKeyPEM = KEYUTIL.getPEM(privateKeyPublicKey)

    return certPublicKeyPEM === privateKeyPublicKeyPEM
  } catch (error) {
    return false
  }  
}

export const checkFullChain = (chain) => {
  try {
    const chainCerts = chain.split(/(?=-----BEGIN CERTIFICATE-----)/g).filter(Boolean)
    const certs = []

    for (let cert of chainCerts) {
      const x509 = new X509()
      x509.readCertPEM(cert)
      certs.push(x509)
    }

    return true
  } catch (error) {
    return false
  }
}

export const getCertificateExpireDate = (pemCert) => {
  try {
    const x509 = new X509()
    x509.readCertPEM(pemCert)

    const notAfter = zulutodate(x509.getNotAfter())
    const notAfterDate = new Date(notAfter)

    return notAfterDate.getFullYear() + '-' + ('0' + (notAfterDate.getMonth() + 1)).slice(-2) + '-' + ('0' + notAfterDate.getDate()).slice(-2)    
  } catch (error) {
    return null
  }
}

export const getDomainFromCertificate = (pemCert) => {
  try {
    const cert = new X509()
    cert.readCertPEM(pemCert)

    const subjectString = cert.getSubjectString()
    const cnMatch = subjectString.match(/CN=([^/]+)/)
    const commonName = cnMatch ? cnMatch[1] : null

    // const sanList = cert.getExtSubjectAltName()
    // const altNames = sanList ? sanList.map(san => san.dns) : []

    return commonName
  } catch (error) {
    return null
  }
}

export const isWildcardMatch = (pattern, domain) => {
  if (pattern.startsWith('*.')) {
    const subDomainPattern = pattern.substring(2)
    return domain.endsWith(`.${subDomainPattern}`)
  }

  return pattern === domain
}